<template>
    <tr class="ibox-title">
        <td class="th-first ibox-title"></td>
        <td class="ibox-title" colspan="4"> {{ title }}</td>
        <td class="text-right ibox-title">{{ currency != 'all' ? sum : '-' | localizeMoney}} </td>
        <td class="ibox-title"></td>
        <td class="ibox-title"></td>
        <td class="text-right ibox-title">{{ sumInBase | localizeMoney }}</td>
        <td class="text-right ibox-title" colspan="2"></td>
        <td class="ibox-title"></td>
    </tr>
</template>

<script>
    import { mapGetters } from 'vuex'
    import filters from './../../../services/Filters.js';

    export default {
        name: 'summary-row',
        props: {
            title: {
                default: ''
            },
            sum: {
                default: '-'
            },
            sumInBase: {
                default: 0
            }
        },
        computed: {
            ...mapGetters({currency : 'getCurrency'})
        },
        filters: filters,
    }
</script>
